module.exports = "//static.hsappstatic.net/ContentComponents/static-2.69719/img/case-study-zero.png"